import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const SomethingWentWrong = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    return (_jsxs("div", { className: 'modal-content something-went-wrong', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('something_went_wrong'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: async () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                        if (location.pathname.includes('admin')) {
                            navigate(APP_ROUTES.adminManageRallies);
                        }
                        else {
                            navigate(APP_ROUTES.rallies);
                        }
                    } }) })] }));
};
export default SomethingWentWrong;
